const ActionTypes = {
  I18N_SET_LANGUAGE: 'I18N_SET_LANGUAGE',
};

export default ActionTypes;
